import { call, put, takeEvery } from "redux-saga/effects"

import {
    GET_ADMIN_INSURANCE_CARRIERS,
    CRETE_ADMIN_INSURANCE_CARRIER,
    UPDATE_ADMIN_INSURANCE_CARRIER
} from "./actionTypes"

import {
    getAdminInsuranceCarriersError,
    getAdminInsuranceCarriersSuccess,
    updateAdminInsuranceCarrierSuccess,
    updateAdminInsuranceCarrierError,
    addAdminInsuranceCarrierSuccess,
    addAdminInsuranceCarrierError,
} from "./actions"

import {
    genericGetRequest, genericPostRequest, genericPutRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetInsuranceCarriers(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_insurance_carriers`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getAdminInsuranceCarriersSuccess(response))
    } catch (error) {
        yield put(getAdminInsuranceCarriersError(error))
    }
}

function* onAddInsuranceCarriers(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_insurance_carriers`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: user.token,
              'Content-Type': 'application/json',
            },
          }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(addAdminInsuranceCarrierSuccess(response))
    } catch (error) {
        yield put(addAdminInsuranceCarrierError(error))
    }
}

function* onUpdateInsuranceCarriers(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_insurance_carriers/${action.payload.id}`;
        const payload = {
            body: JSON.stringify({...action.payload}),
            headers: {
              Authorization: user.token,
              'Content-Type': 'application/json',
            },
          }
        const response = yield call(genericPutRequest, URL, payload)
        yield put(updateAdminInsuranceCarrierSuccess(response))
    } catch (error) {
        yield put(updateAdminInsuranceCarrierError(error))
    }
}

function* AdminInsuranceCarriersSaga() {
    yield takeEvery(GET_ADMIN_INSURANCE_CARRIERS, onGetInsuranceCarriers)
    yield takeEvery(CRETE_ADMIN_INSURANCE_CARRIER, onAddInsuranceCarriers)
    yield takeEvery(UPDATE_ADMIN_INSURANCE_CARRIER, onUpdateInsuranceCarriers)
}

export default AdminInsuranceCarriersSaga

